export default "__VITE_ASSET__ef294c3d__"